module.exports = __webpack_public_path__ + "img/toplogo.b1f61374.png";